import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface UploadGuestsState {
  fileName: string;
}

const formSlice = createGenericFormSlice({
  name: "uploadGuests",
  initialState: {} as SliceState<UploadGuestsState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const uploadGuestsReducer = formSlice.reducer;
export default uploadGuestsReducer;
